<template lang="html">
	<div id="page__cities" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="cities" v-on:refresh="getCities" v-bind:per-page="perPage" 
				v-bind:total="citiesAmount" link table-id="cities" ref="table" v-on:create="addCity"
			>
				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, ZIconButton },
		data() {
			return {
				perPage: 50,
				tableColumns: [
					{ label: 'ID', field: 'id', default: true, sortable: true },
					{ label: 'Название', field: 'name', sortable: true },
					{ label: 'Наименование', field: 'value', sortable: true },
					{ label: 'ОКАТО', field: 'okato', sortable: true },
					{ label: 'ФИАС', field: 'aoguid', sortable: true },
					{ label: '', field: 'actions' }
				],
			}
		},
		metaInfo() {
			return {
				title: 'Города'
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-cities-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
			/**
			 * Список городов
			 */
			cities() {
				return this.$store.state.cost.cities.map(city => {
					city.routerLink = {name: 'City', params: {cityid: city.id}, query: this.$route.query};
					return city;
				});
			},
			/**
			 * Количество городов
			 */
			citiesAmount() {
				return this.$store.state.cost.cities_amount
			}
		},
		created() {
			this.$store.commit('setTitle', 'Города')
		},
		methods: {
			/**
			 * Добавление города
			 */
			addCity() {
				this.$router.push({ name: 'City', params: {cityid: 'new'} });
			},
			/**
			 * Получение городов
			 */
			getCities(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-cities-list');
				return this.$store.dispatch('cost/getCities', {
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count,
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-cities-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), result = {model: [], relation: [], condition: 'and'};

				if (filter.search) result.model = [
					['name',    '%', filter.search], 'or',
					['value',   '%', filter.search], 'or',
					['okato',   '%', filter.search], 'or',
					['aoguid', '%', filter.search]
				];

				return result;
			},
			/**
			 * Удаление города
			 */
			removeCity(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-cities-list');
				this.$store.dispatch('cost/deleteCity', id)
					.then(() => this.$root.$emit('refresh-table', 'cities'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-cities-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления города
			 */
			onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении города?', 'Действие необратимо!',
                    () => this.removeCity(id)
                );
            },
		},
	}
</script>


// WEBPACK FOOTER //
// Cities.vue?f5cde748